/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

// other
import React, { useContext, useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import VacationService from "../../../service/attendance/vacation/vacationService"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import TextInput from "../../../components/InputWrapper/TextInput"

import { FunctionContext } from "../../../components/Context"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../.."
import { showInfoToast } from "../../../components/CustomToast"
import { setAlerts } from "../../../globalStore/alertStore"
import { TApiResponse } from "../../../service/TApiResponse"
import { Button } from "react-bootstrap"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { TVacationGetRes } from "../../../service/attendance/vacation/TVacation"

/**
 * 有休保有数変更モーダル （単体用）
 * @param {*} props
 * @return {*} reactNode
 */
const VacationChangeModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    changeTarget?: TVacationGetRes
  }
> = (props) => {
  //#region [state]
  // 検索用
  const pageSearch = useContext(FunctionContext)

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // 固定
  const [部所名, set部所名] = useState<string>()
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()

  // 編集項目
  const [繰越日数, set繰越日数] = useState<number>()
  const [付与日数, set付与日数] = useState<number>()
  const [初期繰越日数, set初期繰越日数] = useState<number>()
  const [初期付与日数, set初期付与日数] = useState<number>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  //#endregion

  // #region [method]

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      const service = new VacationService()
      const isUpdate = 0 < (props.changeTarget!.有休残管理ID ?? 0)

      let res: TApiResponse<boolean>

      if (isUpdate) {
        res = await service.putSyaryoSyozokuFrom(
          props.changeTarget!.有休残管理ID!,
          {
            更新日時: props.changeTarget!.更新日時!,
            付与日数: 付与日数 ?? 0,
            繰越日数: 繰越日数 ?? 0,
          }
        )
      } else {
        res = await service.postSyaryoSyozokuFrom({
          付与年度: parseInt(props.changeTarget!.年度),
          付与対象社員コード: props.changeTarget!.社員コード,
          付与日数: 付与日数 ?? 0,
          繰越日数: 繰越日数 ?? 0,
        })
      }

      disPatch(setAlerts(res))
      if (res) {
        props.setIsShow(false)
        showInfoToast(`有休保有数の更新が完了しました`)
        pageSearch()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (props.isShow) {
      setAlertSource(undefined)
      setIsSpinnerShow(true)

      if (props.changeTarget != null) {
        set部所名(props.changeTarget.部所略称)
        set社員コード(props.changeTarget.社員コード)
        set社員氏名(props.changeTarget.社員氏名)

        const isUpdate = 0 < (props.changeTarget.有休残管理ID ?? 0)

        if (isUpdate) {
          set繰越日数(props.changeTarget.繰越日数)
          set付与日数(props.changeTarget.付与日数)
          set初期繰越日数(props.changeTarget.繰越日数)
          set初期付与日数(props.changeTarget.付与日数)
        } else {
          set繰越日数(0)
          set付与日数(0)
          set初期繰越日数(0)
          set初期付与日数(0)
        }
      }

      setIsSpinnerShow(false)
    } else {
      // MEMO: 表示時にState変数入れ替えてるので非表示時は何もしない（WijmoのComponentでループしちゃう）
      // 非表示時中身を空にして閉じる
      //   set社員コード("")
      //   set社員氏名("")
      //   set部所名("")
      //   set繰越日数(undefined)
      //   set付与日数(undefined)
      //   set初期繰越日数(undefined)
      //   set初期付与日数(undefined)
      //   set削除フラグ(0)
      //   set更新日時("")
      //   setIsSpinnerShow(false)
    }
  }, [props.isShow])

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "保有数変更"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <>
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            更新
          </Button>
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="register-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <TextInput
                    id="部所"
                    name="部所"
                    value={部所名}
                    isReadOnly={true}
                    setValue={set部所名}
                    maxLength={100}
                    placeholder="部所"
                    style={{ width: "200px" }}
                  />
                </li>
                <li className="list-cmn d-flex">
                  <TextInput
                    id="社員コード"
                    name="社員コード"
                    value={社員コード}
                    isReadOnly={true}
                    setValue={set社員コード}
                    maxLength={60}
                    placeholder="社員コード"
                  />
                  <TextInput
                    id="社員氏名"
                    name="社員氏名"
                    value={社員氏名}
                    isReadOnly={true}
                    setValue={set社員氏名}
                    maxLength={100}
                    placeholder="社員氏名"
                  />
                </li>
              </ul>
            </Col>
          </Row>

          <MasterRegisterFormRow label="">
            <div>
              <div className="d-flex">
                <div className="4rem">
                  <TextInput
                    id="項目名"
                    name="項目名"
                    value={"項目名"}
                    isReadOnly={true}
                    setValue={() => {}}
                  />
                </div>
                <div className="4rem">
                  <TextInput
                    id="変更前"
                    name="変更前"
                    value={"変更前"}
                    isReadOnly={true}
                    setValue={() => {}}
                  />
                </div>
                <div className="4rem">
                  <TextInput
                    id="変更後"
                    name="変更後"
                    value={"変更後"}
                    isReadOnly={true}
                    setValue={() => {}}
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="4rem">
                  <TextInput
                    id="繰越数"
                    name="繰越数"
                    value={"繰越数"}
                    isReadOnly={true}
                    setValue={() => {}}
                  />
                </div>
                <div className="4rem">
                  <wjrInput.InputNumber
                    id="初期繰越日数"
                    name="初期繰越日数"
                    format="N1"
                    isReadOnly={true}
                    value={初期繰越日数}
                  />
                </div>
                <div className="4rem">
                  <wjrInput.InputNumber
                    initialized={(control: wjcInput.InputNumber) => {
                      control.inputElement?.focus()
                    }}
                    id="繰越日数"
                    name="繰越日数"
                    format="N1"
                    isRequired={true}
                    value={繰越日数}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null
                        ? set繰越日数(c.value)
                        : set繰越日数(undefined)
                    }}
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="4rem">
                  <TextInput
                    id="付与数"
                    name="付与数"
                    value={"付与数"}
                    isReadOnly={true}
                    setValue={() => {}}
                  />
                </div>
                <div className="4rem">
                  <wjrInput.InputNumber
                    initialized={(control: wjcInput.InputNumber) => {
                      control.inputElement?.focus()
                    }}
                    id="初期付与日数"
                    name="初期付与日数"
                    format="N1"
                    isReadOnly={true}
                    value={初期付与日数}
                  />
                </div>
                <div className="4rem">
                  <wjrInput.InputNumber
                    id="付与日数"
                    name="付与日数"
                    format="N1"
                    isRequired={true}
                    value={付与日数}
                    valueChanged={(c: wjcInput.InputNumber, e: any) => {
                      c.value != null
                        ? set付与日数(c.value)
                        : set付与日数(undefined)
                    }}
                  />
                </div>
              </div>
            </div>
          </MasterRegisterFormRow>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default VacationChangeModal
